import { render, staticRenderFns } from "./QuestionCategoryHandler.vue?vue&type=template&id=2f45690a"
import script from "./QuestionCategoryHandler.vue?vue&type=script&lang=js"
export * from "./QuestionCategoryHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports